import { TaskTypes } from '../../../features/tasks/types/taskTypes';
import { Stage } from '../../constants/stage';
import { TaskState } from '../../constants/states';
import {
  QuickFiltersList,
  QuickFilterType,
} from '../../interfaces/quickFilters/QuickFilters';
import {
  ApplicationSortSetting,
  TaskSort,
} from '../../interfaces/quickFilters/TaskQueryRequest';

export const NeedsDecision = [
  Stage.INITIAL_REVIEW,
  Stage.READY_FOR_REVIEW,
  Stage.WAITING_FOR_EVIDENCE,
  Stage.READY_FOR_DECISION,
  Stage.POST_ISSUE_AUDIT,
];

export const MostRecentFirst: ApplicationSortSetting[] = [
  { field: TaskSort.CreatedAt, asc: false },
];

export const RUWBeforePIA: ApplicationSortSetting[] = [
  { field: TaskSort.LifeCycle, asc: true },
  { field: TaskSort.Sla, asc: true },
];

export const BiggestSLA: ApplicationSortSetting[] = [
  { field: TaskSort.Sla, asc: true },
];

export const IntegraCMTasks = [
  TaskTypes.APS,
  TaskTypes.EHR,
  TaskTypes.INSURANCE_LABS,
  TaskTypes.LAB_PIQTURE,
  TaskTypes.MEDICAL_CLAIMS,
  TaskTypes.SCRIPT_CHECK,
];

export const EspCMTasks = [
  TaskTypes.LETTER,
  TaskTypes.MIB_CODE_DETAILS,
  TaskTypes.MIB_CODEBACK,
];

export const BuildTaskRequestsFilter = (
  taskTypes: TaskTypes[],
): QuickFiltersList[] => {
  return taskTypes.map(t => {
    const taskTypeDisplayText = taskTypeToQuickFiltersDisplay(t);
    return {
      display: taskTypeDisplayText,
      quickFilterType: QuickFilterType.TASK_LIST_VIEW,
      queryBody: {
        taskType: [t],
        taskState: [TaskState.REQUESTED],
        sort: RUWBeforePIA,
      },
      title: `${taskTypeDisplayText} requests`,
    };
  });
};

export const BuildTasksOrderedFilter = (
  taskTypes: TaskTypes[],
): QuickFiltersList[] => {
  return taskTypes.map(t => {
    const taskTypeDisplayText = taskTypeToQuickFiltersDisplay(t);
    return {
      display: taskTypeDisplayText,
      quickFilterType: QuickFilterType.TASK_LIST_VIEW,
      queryBody: {
        taskType: [t],
        taskState: [TaskState.ORDERED],
        sort: RUWBeforePIA,
      },
      title: `${taskTypeDisplayText} ordered`,
    };
  });
};

// Returns the more user friendly display string for different tasks.
// We either display custom ones e.g. MIB, RX, LabPiQture
// or by default, capitalizing the first word e.g. Criminal records
const taskTypeToQuickFiltersDisplay = (task: TaskTypes): string => {
  if (customTasksDisplay.has(task)) {
    return customTasksDisplay.get(task) as string;
  }
  return task
    .split('_')
    .map((t, i) =>
      i === 0 ? t.charAt(0) + t.slice(1).toLowerCase() : t.toLowerCase(),
    )
    .join(' ');
};

// AllUppercaseTasks are tasks that needs to display with all uppercase
const customTasksDisplay = new Map<TaskTypes, string>([
  [TaskTypes.APS, 'APS'],
  [TaskTypes.EHR, 'EHR'],
  [TaskTypes.ETI, 'ETI'],
  [TaskTypes.TRL, 'TRL'],
  [TaskTypes.MVR, 'MVR'],
  [TaskTypes.MIB, 'MIB'],
  [TaskTypes.RX, 'RX'],
  [TaskTypes.LAB_PIQTURE, 'LabPiQture'],
  [TaskTypes.SCRIPT_CHECK, 'ScriptCheck'],
  [TaskTypes.MIB_CODEBACK, 'MIB codeback'],
  [TaskTypes.MIB_CODE_DETAILS, 'MIB code details'],
]);
